import {useTranslation} from 'react-i18next';
import {ICandle} from '../../types/resources/Candle';
import React, {useState} from 'react';
import CandleCard from './CandleCard';
import {ViewMode} from '../../enums/ViewMode';
import PaginatedCollection from '../PaginatedCollection';
import CandleForm from './CandleForm';
import {IOnlineCondolenceDetails} from '../../types/resources/OnlineCondolenceDetails';
import styled from 'styled-components';

const CandleHeader = styled.div`
    @media (max-width: 768px) {
        && {
            align-items: center;
            flex-direction: column;
            gap: var(--cr-spacing-lg);
            text-align: center;
            text-wrap: balance;
        }
    }
`;

type TProps = {
    onlineCondolence: IOnlineCondolenceDetails;
    isCandleLightingEnabled: boolean;
    candles: ICandle[];
}

const CandleCollection = ({onlineCondolence, isCandleLightingEnabled, candles}: TProps) => {
    const { t } = useTranslation();
    const [isFormShown, setIsFormShown] = useState<boolean>(false);
    const [candleLit, setCandleLit] = useState<ICandle[]>(candles);

    const renderCard = (candle: ICandle, index: number) => (
        <CandleCard
            key={index}
            candle={candle}
        />
    );

    const handleCandleLit = (newCandle: ICandle) => {
        setCandleLit(prevCandles => [newCandle, ...prevCandles]);
    };

    const showCandles = (candleLit.length > 0);

    return (showCandles || isCandleLightingEnabled) ? (
        <div className="cr-my-xl cr-container">
            {isCandleLightingEnabled &&
                <CandleHeader className="cr-flex cr-justify-between cr-align-baseline cr-py-xl">
                    <div className="cr-text-title cr-text-alert cr-bold">{t('light-candle-title')}</div>
                        <button
                            className="cr-pill cr-bg-alert cr-text-white cr-text-base"
                            onClick={() => setIsFormShown(!isFormShown)}
                        >
                            {t('light-candle')}
                        </button>
                </CandleHeader>
            }
            {isFormShown &&
                <CandleForm
                    onlineCondolence={onlineCondolence}
                    hideForm={() => setIsFormShown(false)}
                    onCandleLit={handleCandleLit}
                />
            }
            {showCandles &&
                <PaginatedCollection
                    id={'candleCollection'}
                    items={candleLit}
                    renderItems={{
                        [ViewMode.GridView]: renderCard,
                    }}
                    itemsPerPage={12}
                    itemsPerRow={6}
                    itemsPerRowTablet={4}
                    itemsPerRowMobile={2}
                    viewMode={ViewMode.GridView}
                />
            }
        </div>
    ) : null;
}

export default CandleCollection;
